<script setup lang="ts">
import { RouterView } from 'vue-router'
import Toaster from '@/components/ui/toast/Toaster.vue'
</script>

<template>
  <RouterView />
  <Toaster />
</template>

<style scoped>
</style>
